<template>
    <crm-content no-padding>
        <template v-slot:actionLeft>
            <vx-action-icon
                icon="MenuIcon"
                class="mr-4"
                @click="$emit('toggle-side-bar', $event)"
            />
            <h5 class="line-height-inherit">Dashboard</h5>
        </template>
        <vx-dashboard
            ref="dashboard"
            type="CRM"
            :supported-components="widgets"
            v-if="userHasRole(['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'])"
        />
    </crm-content>
</template>

<script>
import CrmContent from '../../crm/components/CrmContent'
import PatientLookupWidget from '../PatientLookupWidget.vue'
import RequestLookupWidget from '../RequestLookupWidget.vue'
// import CrmMultiSearch from '../../components/CrmMultiSearch'
// import AccountStatWidget from '@/components/widgets/AccountStats/AccountStatWidget.vue'
// import FilteredCountWidget from '@/components/widgets/CrmSummaries/FilteredCountWidget.vue'
// import SpacerWidget from '@/components/widgets/SpacerWidget.vue'
// import StatementFinderWidget from '@/components/widgets/StatementFinderWidget.vue'
// import TopProactiveRefreshWidget from '@/components/widgets/ProactiveRefresh/TopProactiveRefreshWidget.vue'
// import MyCountsWidget from '@/components/widgets/MyCountsWidget.vue'
// import OrderSummaryWidget from '@/components/widgets/CrmSummaries/OrderSummaryWidget.vue'
// import QuoteSummaryWidget from '@/components/widgets/CrmSummaries/QuoteSummaryWidget.vue'
// import YearlyInvoiceSummaryWidget from '@/components/widgets/CrmSummaries/InvoiceSummaries/YearlyInvoiceSummaryWidget.vue'
// import MonthlyInvoiceSummaryWidget from '@/components/widgets/CrmSummaries/InvoiceSummaries/MonthlyInvoiceSummaryWidget.vue'
// import LeaderBoardWidget from '@/components/widgets/LeaderBoardWidget.vue'
// import LeadsSummaryWidget from '@/components/widgets/CrmSummaries/LeadsSummaryWidget.vue'
// import OpportunitiesSummaryWidget from '../../../../components/widgets/CrmSummaries/OpportunitiesCountSummaryWidget.vue'
// import OpportunitiesExpectedValueSummaryWidget from '../../../../components/widgets/CrmSummaries/OpportunitiesExpectedValueSummaryWidget.vue'
// import MyOpportunitiesSummaryWidget from '../../../../components/widgets/CrmSummaries/MyOpportunitiesSummaryWidget.vue'

export default {
    name: 'dashboard-library',
    components: {
        CrmContent,
        PatientLookupWidget,
        RequestLookupWidget
        // CrmMultiSearch
    },
    props: {},
    data() {
        return {
            widgets: [PatientLookupWidget, RequestLookupWidget]
        }
    }
    // async beforeRouteLeave(to, from, next) {
    //     if (await this.$refs.dashboard.confirmLeave(to, from)) {
    //         next()
    //     }
    // }
}
</script>

<style scoped lang="scss">
.line-height-inherit {
    line-height: inherit;
}

.content {
    ::v-deep .expense__actions {
        padding: 0 !important;
    }
}
</style>
